let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("crMsn")).then(() => parcelRequire('jvn8u'));